import { DiscountedPrice } from '@/components/base/discounted-price/discounted-price';
import Skeleton from '@/components/base/skeleton/skeleton';
import TextSkeleton from '@/components/base/skeleton/text-skeleton';
import { useAddProductToCartMutation } from '@/features/basket/api/mutation/change-product-quantity';
import ProductImage from '@/features/basket/components/product-card/product-image';
import QuantityStepper from '@/features/basket/components/product-card/quantity-stepper';
import type { Product as ProductType } from '@/features/basket/types/product';

interface Props {
  product: ProductType;
}

export const Product = ({ product }: Props) => {
  const changeQuantityMutation = useAddProductToCartMutation();

  return (
    <div className="flex gap-xs no-flex-gap:space-x-xs">
      <ProductImage
        imageId={product.pictureId}
        parentId={product.parentId}
        priority
        width={126}
        className="h-[84px] w-[126px] min-w-[126px]"
        alt=""
      />
      <div className="w-full">
        <h2
          role="heading"
          aria-label={product.name}
          tabIndex={0}
          className="text-body-bold text-default"
        >
          {product.name}
        </h2>
        <div className="flex items-center justify-between">
          <div className="ml-[-10px]">
            <QuantityStepper
              quantity={product.quantity}
              product={product}
              mutation={changeQuantityMutation}
            />
          </div>
          <DiscountedPrice
            price={product.price}
            priceBeforeDiscount={product.priceBeforeDiscount}
          />
        </div>
      </div>
    </div>
  );
};

const ProductSkeleton = () => {
  return (
    <div className="flex gap-xs">
      <Skeleton className="h-[84px] w-[126px] min-w-[126px]" />
      <div className="flex w-full flex-col justify-between">
        <TextSkeleton className="w-full" />
        <div className="flex w-full items-center justify-between">
          <TextSkeleton className="w-1/4" />
          <TextSkeleton className="w-2/5" />
        </div>
      </div>
    </div>
  );
};

Product.Skeleton = ProductSkeleton;
